<div *transloco="let t" class="detail-background p-6">
	<div class="periods-section w-full">
		<div class="section-header flex items-center justify-between gap-2">
			<div class="flex items-center gap-2">
				<mat-icon fontSet="material-symbols-outlined" class="text-primary">family_group</mat-icon>
				<h3 class="text-lg font-medium m-0">{{ t('billing.tenantDateTitle') }}</h3>
			</div>
			<mat-icon [matTooltip]="t('billing.tenantDataInfoTooltip')" matTooltipClass="multiline-tooltip" [svgIcon]="icons.get('infoOutline')"></mat-icon>
		</div>
	</div>
	<mat-tab-group [mat-stretch-tabs]="false" preserveContent>
		<mat-tab label="{{ t('billing.tenantData') }}">
			<ng-template matTabContent>
				<ara-tenant-unit-references-master [billingId]="billingId()"></ara-tenant-unit-references-master>
			</ng-template>
		</mat-tab>
		<mat-tab label="{{ t('billing.parameterDefinition') }}">
			<ng-template matTabContent>
				<vex-parameters [billingId]="billingId()"></vex-parameters>
			</ng-template>
		</mat-tab>
	</mat-tab-group>
</div>
